import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters('prohub/notificationsStore', [
      'notifications',
      'getNotificationById',
      'getNotificationRouteById',
      'dateGroupedNotifications',
      'notificationsMetadata',
    ]),
  },
  mounted () {
    this.fetchNotifications();
  },
  methods: {
    ...mapActions('prohub/notificationsStore', [
      'fetchNotifications',
      'fetchMoreNotifications',
      'fetchUnseenNotifications',
      'markNotificationAsRead',
      'markAllNotificationsAsSeen',
    ]),
  },
};
